import { Transition } from "@headlessui/react";
import MyAccountCard from "@routes/MyAccount/components/MyAccountCard";
import { MyAccountReadingHistoryProps } from "@routes/MyAccount/utils/types";

/**
 * MyAccountReadingHistoryList is a component that displays the list of articles in the reading history.
 * Figma: https://www.figma.com/design/soi1ZhMqZHbss6tJLvLgaa/MY-ACCOUNT--WEB-?node-id=3707-35565&t=1IQZnRIEwkg358qY-4
 */
const MyAccountReadingHistoryList = ({
  articleList,
  loadMoreRef,
  handleDeleteArticle,
  deleteArticleIdList,
}: MyAccountReadingHistoryProps): React.ReactElement => {
  const handleDeleteArticleT = (id: string) => {
    handleDeleteArticle(id);
  };

  return (
    <div data-testid="my-account-reading-history-list-component">
      {articleList.map((article) => {
        const _id = article.id.toString();
        const isDeleted = deleteArticleIdList.includes(_id);

        return (
          <Transition
            as={"div"}
            show={!isDeleted}
            key={_id}
            className="relative overflow-hidden transition-all duration-500"
            leaveFrom="opacity-100 max-h-96 top-0"
            leaveTo="opacity-0 max-h-0 top-[-50px]"
          >
            <MyAccountCard
              article={article}
              handleDeleteArticle={(id) => {
                handleDeleteArticleT(id);
              }}
              isDisplayDeleteButton={true}
            />
          </Transition>
        );
      })}

      <div ref={loadMoreRef} />
    </div>
  );
};

export default MyAccountReadingHistoryList;
